export const formatPhoneNumber = (phoneNumber) => {
  const formattedPhoneNumber = phoneNumber.replace(/(\d{3})(\d{7})/, "0($1)$2");
  return formattedPhoneNumber;
};


